module.exports = __webpack_public_path__ + "static/media/cybersecurity.2bf73808.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/TeamBox/img/cybersecurity.svg
// module id = 79
// module chunks = 0